import { Tooltip } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

export const EnterpriseTooltip = withStyles(theme => ({
  tooltip: {
    backgroundColor: '#355E84',
    color: 'theme.palette.common.white',
    boxShadow: theme.shadows[1],
    fontSize: theme.typography.pxToRem(14),
  },
}))(Tooltip);
